import React from 'react';
import Icon from '../../../components/AppIcon';

const MarketOverviewCard = ({ market, price, change, changePercent, volume, isPositive }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-elevated transition-shadow duration-200">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
            market === 'EUA' ? 'bg-success/10' : 'bg-warning/10'
          }`}>
            <Icon 
              name={market === 'EUA' ? 'Leaf' : 'Fuel'} 
              size={20} 
              className={market === 'EUA' ? 'text-success' : 'text-warning'} 
            />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">{market}</h3>
            <p className="text-sm text-muted-foreground">
              {market === 'EUA' ? 'EU Allowances' : 'Crude Oil Futures'}
            </p>
          </div>
        </div>
        <div className={`flex items-center gap-1 ${isPositive ? 'text-success' : 'text-error'}`}>
          <Icon name={isPositive ? 'TrendingUp' : 'TrendingDown'} size={16} />
        </div>
      </div>
      
      <div className="space-y-2">
        <div className="flex items-baseline gap-2">
          <span className="text-2xl font-bold text-foreground">{price}</span>
          <span className="text-sm text-muted-foreground">
            {market === 'EUA' ? 'EUR/tCO2' : 'USD/bbl'}
          </span>
        </div>
        
        <div className="flex items-center gap-4">
          <div className={`flex items-center gap-1 ${isPositive ? 'text-success' : 'text-error'}`}>
            <span className="text-sm font-medium">{change}</span>
            <span className="text-sm">({changePercent}%)</span>
          </div>
          <div className="text-sm text-muted-foreground">
            Vol: {volume}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketOverviewCard;